import React from "react";
import PropTypes from "prop-types";
import { Stack, Link, Heading, Text } from "@chakra-ui/react";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { Markup } from "interweave";

const References = (props) => {
  const { references } = props;

  if (!references || references.length === 0) return null;

  return (
    <Stack marginBottom="1rem">
      <Heading size="lg" fontWeight="normal">
        References
      </Heading>
      {references.map((ref, index) => {
        const { reference, doi, pubmedId } = ref;
        return (
          <Stack key={`reference-${index}`}>
            <Text fontFamily="Noto serif, serif">
              <Markup content={reference} />
              {pubmedId && (
                <Link
                  href={`https://www.ncbi.nlm.nih.gov/pubmed/${pubmedId}`}
                  isExternal
                >
                  PubMed
                  <ExternalLinkIcon mx="2px" />
                </Link>
              )}
              {doi && (
                <Link href={`https://doi.org/${doi}`} isExternal>
                  {doi}
                  <ExternalLinkIcon mx="2px" />
                </Link>
              )}
            </Text>
          </Stack>
        );
      })}
    </Stack>
  );
};

References.propTypes = {
  references: PropTypes.arrayOf(
    PropTypes.shape({
      reference: PropTypes.string,
      doi: PropTypes.string,
      pubMedId: PropTypes.string,
    })
  ),
};

export default References;
